import {createSlice} from '@reduxjs/toolkit';

import storeSliceNames from '../../consts/storeSliceNames';

const initialState = {
    isAuthorized: false,
    firstName: '',
    lastName: '',
    userName: '',
    userId: '',
    authTime: null,
    userRoles: [],
    userGroups: [],
    userChannel: null,
    locationId: null,
};

const authSlice = createSlice({
    name: storeSliceNames.auth,
    initialState,
    reducers: {
        setIsAuthorized(state, action) {
            state.isAuthorized = action.payload;
        },
        setFirstName(state, action) {
            state.firstName = action.payload;
        },
        setLastName(state, action) {
            state.lastName = action.payload;
        },
        setUserName(state, action) {
            state.userName = action.payload;
        },
        setUserId(state, action) {
            state.userId = action.payload;
        },
        setAuthTime(state, action) {
            state.authTime = action.payload;
        },
        setUserRoles(state, action) {
            state.userRoles = action.payload;
        },
        setUserGroups(state, action) {
            state.userGroups = action.payload;
        },
        setUserChannel(state, action) {
            state.userChannel = action.payload;
        },
        setLocationId(state, action) {
            state.locationId = action.payload;
        },
        clearAuthData() {
            return initialState;
        },
    },
});

export const setIsAuthorized = (isAuthorized) => authSlice.actions.setIsAuthorized(isAuthorized);

export const setFirstName = (firstName) => authSlice.actions.setFirstName(firstName);

export const setLastName = (lastName) => authSlice.actions.setLastName(lastName);

export const setUserName = (userName) => authSlice.actions.setUserName(userName);

export const setUserId = (userId) => authSlice.actions.setUserId(userId);

export const setAuthTime = (timestamp) => authSlice.actions.setAuthTime(timestamp);

export const setUserRoles = (groups) => authSlice.actions.setUserRoles(groups);

export const setUserGroups = (groups) => authSlice.actions.setUserGroups(groups);

export const setUserChannel = (channel) => authSlice.actions.setUserChannel(channel);

export const setLocationId = (locationId) => authSlice.actions.setLocationId(locationId);

export const clearAuthData = () => authSlice.actions.clearAuthData();

export default authSlice.reducer;
